import { raiseToast } from '@fiverr-private/toast';
import { translate } from '../translate';

export const raiseErrorToast = (message: string = translate('errors.general')) =>
    raiseToast({
        message,
        type: 'error',
        location: 'top',
    });
